import { type ReactNode } from "react";
import { Group, Text } from "@mantine/core";

interface CaseInfoRowProps {
  label: string;
  value?: ReactNode | null;
}

const LABEL_WIDTH = 120;

export function CaseInfoRow({ label, value }: CaseInfoRowProps) {
  if (!value) return null;

  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Text
        size="xs"
        fw={600}
        c="dimmed"
        tt="uppercase"
        style={{ minWidth: LABEL_WIDTH, flexShrink: 0 }}
      >
        {label}:
      </Text>
      {typeof value === "string" ? <Text size="xs">{value}</Text> : value}
    </Group>
  );
}
